import React from 'react';
import ProductPassport from 'app/components/product/ProductPassport';
import { searchProductNextPage } from 'app/dispatcher/searchDispatcher';
import { Paginate } from 'app/seedly-component-library';
import formatTimeago from 'app/utils/formatTimeago';
import Spinner from 'seedly-component-library/spinner-new';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'app/reducer';

const UserReview = ({ reviewText, updatedAt }) => {
  if (!reviewText) return null;

  const formattedReview = `"${reviewText
    .split(' ')
    .slice(0, 20)
    .join(' ')}..."`;
  const dateAgo = formatTimeago(updatedAt, { cutoff: false });

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <p className="text text-neutral-500">
        {formattedReview}
        <span style={{ fontWeight: 'bold' }}> {dateAgo}</span>
      </p>
    </div>
  );
};

const ProductSearchList = props => {
  const { onPageChange, searchTerm, limit } = props;

  const productMeta = useSelector((state: RootState) => state.product.meta);
  const products = useSelector((state: RootState) => state.product.products);
  const slicedProducts = limit ? products.slice(0, limit) : products;
  const isFetching = useSelector(
    (state: RootState) => state.product.api.isFetching,
  );

  const dispatch = useDispatch();

  const { currentPage, totalPage } = productMeta.pagination;
  const renderPaginate = totalPage && totalPage > 1 && !limit;

  const handleLoadMoreProducts = data => {
    if (onPageChange) onPageChange();
    const page = data.selected + 1;
    const searchParams = { term: searchTerm, page };
    return dispatch(searchProductNextPage(searchParams));
  };

  const dataSource = slicedProducts.map(product => {
    const { review } = product;
    return (
      <div className="p-4 bg-white rounded-lg h-fit w-full" key={product.id}>
        <ProductPassport product={product} />
        {review && (
          <UserReview reviewText={review.text} updatedAt={review.updated_at} />
        )}
      </div>
    );
  });

  if (isFetching) {
    return (
      <div data-testid="spinner" className="flex flex-col w-full items-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center w-full">
      <div className="list ">{dataSource}</div>
      {renderPaginate && (
        <div className="flex flex-col gap-4 mt-3">
          <Paginate
            pageCount={totalPage}
            forcePage={currentPage - 1}
            onPageChange={handleLoadMoreProducts}
          />
        </div>
      )}
    </div>
  );
};

export default ProductSearchList;
